import React from 'react';

import { messagesModel } from '@/features';
import { EXPERIMENTS } from '@/constants';

import { useAppExperiments } from 'AiAssistantWidget/experiments';

import { MessageOptions } from './MessageOptions';
import { MessageFields } from './MessageFields';

export const VisitorOptions: React.FC<{
  message: messagesModel.Message;
}> = ({ message }) => {
  const { experiments } = useAppExperiments();
  const shouldRenderOptions = experiments.enabled(
    EXPERIMENTS.RENDER_AI_MESSAGE_OPTIONS,
  );

  if (shouldRenderOptions && messagesModel.hasVisitorOptionsFields(message)) {
    return (
      <MessageFields
        messageId={message.id}
        visitorOptionsFields={message.visitorOptionsFields}
        options={message.visitorOptions}
      />
    );
  }

  if (shouldRenderOptions && messagesModel.hasVisitorOptions(message)) {
    return (
      <MessageOptions messageId={message.id} options={message.visitorOptions} />
    );
  }

  return null;
};
